/* eslint-disable */
import * as H from 'history';
import  React from 'react';
import { ApplicationController } from '../../../../../controllers/ApplicationController';
import { ApplicationModel } from '../../../../../models/ApplicationModel';
import { BusinessPartnerModel } from "../../../../../models/BusinessPartnerModel";
import { ISupportSpinner } from '../../../../../shared/Ajax';
import { Backdrop } from '../../../../../shared/Backdrop';
import { Table } from '../../../../../shared/table';
import { SaveCancelButtons } from '../../../../../../client/pages/applicationForm-1/controls/SaveCancelButtons';
import { businessPartnerColumns, BusinessPartnerDetails } from './BusinessPartnerDetails';


export interface BusinessPartnerPageProps {
    history: H.History
    model: ApplicationModel
    onChange: { (changes: Partial<ApplicationModel>, callback?: { (): any }): any }
}

export interface BusinessPartnerPageState {
    loading: boolean
    businessPartnerModel: BusinessPartnerModel[]
}

export class BusinessPartnerPage extends React.Component<BusinessPartnerPageProps, BusinessPartnerPageState> implements ISupportSpinner {
    ajax: ApplicationController
    table: Table<BusinessPartnerModel>

    constructor(props: BusinessPartnerPageProps) {
        super(props);

        this.ajax = new ApplicationController();

        this.state = {
            loading: false,
            businessPartnerModel: props.model.businessPartners ? props.model.businessPartners.map(r => r) : []
        }
    }

    componentDidMount() {
    }

    componentWillUnmount() {
        this.ajax.cancel();
    }

    toggleSpinner(on: boolean, callback: { (): any }): void {
        this.setState({ loading: on }, callback);
    }

    save = () => {
        this.table.saveAndClose(res => {
            
            if (res) {
                if (this.state.businessPartnerModel.filter(r => r.invalid).length === 0) {
                    //upgrade fix: 'applicationID' field in JavaScript is an empty string, which cannot be converted to a nullable Guid (Guid?) when model-binding takes place in the C# Controller action-method;
                    //if applicationID = '', set it to null, so it can be converted to nullable Guid?
                    const updatedBusinessPartners = this.state.businessPartnerModel.map(partner => {
                        if (partner.applicationID === "") {
                            return { ...partner, applicationID: null };
                        }
                        return partner;
                    });
                    const updatedModel = { ...this.props.model, businessPartners: updatedBusinessPartners }

                    this.ajax.updateBusinessPartners(this, updatedModel, (d) => {
                        this.props.onChange({ ...this.props.model, ...d });
                        this.props.history.goBack();
                    })
                }
                else {
                    alert("Please correct records marked with the warning sign.");
                }
            }
        });
    }

    render() {
        let columns = [...businessPartnerColumns];

        var sortedList = this.state.businessPartnerModel.slice();
        sortedList.sort((a, b) => a.invalid ? -1 : 1);

        return <>
            <SaveCancelButtons onCancel={this.props.history.goBack} onSave={this.save} />
            <h2 className="mt-3">Directors or Partners</h2>
            <p className="mt-3 mb-3">{`Enter the names of company directors or partners in the partnership.`} </p>
            <Table<BusinessPartnerModel>
                id="table"
                label="Directors or partners in the partnership"
                ref={r => this.table = r}
                value={sortedList}
                onChange={businessPartnerModel => this.setState({ businessPartnerModel })}
                columns={columns}
                renderSection={(p) => <BusinessPartnerDetails {...p} />}
                allowEdit={true}
                alwaysShowAllRows={true}
            />

            <SaveCancelButtons onCancel={this.props.history.goBack} onSave={this.save} />

            <Backdrop on={this.state.loading} />
        </>
    }
}